// eslint-disable-next-line @typescript-eslint/no-unused-vars
import UIkit from 'uikit/dist/js/uikit-core';
import initSlideshows from './theme/slideshow';
import initHeader from './theme/header';
import initSecondaryHeader from './theme/secondaryHeader';
import initRealtyMap from './theme/realtyMap';
import initConstructionMap from './theme/constructionMap';
import initHeroText from './theme/heroText';
import initPortfolioSlideshow from './theme/portfolioSlideshow';
import initDevelopmentMap from './theme/developmentMap';
import initMessageBanner from './theme/messageBanner';
import initSearchForm from './theme/searchForm';

const parentThemeScripts = () => {
    initMessageBanner();
    initHeroText();
    initSlideshows();
    initHeader();
    initSecondaryHeader();
    initRealtyMap();
    initConstructionMap();
    initPortfolioSlideshow();
    initDevelopmentMap();
    initSearchForm();
}

parentThemeScripts();

export default parentThemeScripts;